<template>
    <div class="modal fade" :class="{'is-open': open}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">調撥明細</h3>
                </div>
                <div class="modal-body" v-if="open">
                    <section class="search pb-0 mb-4">
                        <div class="row" :class="{
                        'section-loading': isLoading
                        }">
                            <div class="col-md-12" v-if="tableData.length > 0">
                                <table class="table datatable insurance-green">
                                    <thead>
                                        <tr>
                                            <th>要保人</th>
                                            <th>保單號碼</th>
                                            <th>原服務人員</th>
                                            <th>新服務人員</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, rid) in tableData" :key="`row-${rid}-${row.ceplcno}`">
                                            <td>{{row.ceapcnm | getMaskName}}</td>
                                            <td>{{row.ceplcno}}</td>
                                            <td>
                                                {{row.agname_old}}<br/>
                                                {{row.ceclcno_old}}
                                            </td>
                                            <td>
                                                {{row.agname_new}}<br/>
                                                {{row.ceclcno_new}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12" v-else>
                                查無資料
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransferModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        detailList: {
            type: Array,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        'detailList': 'syncData',
        open (val) {
            if (val) {
                this.registerHanlink()
            }
        }
    },
    data () {
        return {
            tableData: []
        }
    },
    methods: {
        syncData() {
            this.tableData = this.detailList
        },
        compareWithDivNo(clcNo, divNo){
            //divNo第三碼若為4，須調整為5做比較
            if (divNo[2] === '4') {
                divNo = divNo.slice(0, 2) + '5' + divNo.slice(3);
            }
            return clcNo.slice(0,3) == divNo.slice(0,3)
        },
    }
}
</script>

<style>

</style>
